module.exports = __webpack_public_path__ + "assets/font/MiSans-Bold-79e888d8.woff2";